// 🖋️ Ink 듣기 — 화면의 본문을 「읽힐 글」 로 다듬는 일. 화면(DOM) 없이도 잴 수 있게 따로 떼어 둔다.
//
//   ① 한자 병기를 뺀다 — 「사천(四川)의 아미산(峨眉山)」 → 「사천의 아미산」
//   ② 문장으로 자른다 — 한 번에 읽히는 토막이 길면 소리가 끊기는 브라우저가 있다

// 한 토막의 길이. 넘는 문장은 쉼표에서, 그래도 넘으면 빈칸에서 더 자른다.
export const CHUNK_MAX = 100;

// 괄호 안이 한자(와 가운뎃점 · 빈칸)뿐인 것만 뺀다. 한글이 든 괄호는 그대로 둔다.
const HANJA_NOTE = /\s*[(（][㐀-䶿一-鿿豈-﫿\u{20000}-\u{2ebef}·ㆍ・‧\s]+[)）]/gu;

export function dropHanja(text: string): string {
    return text.replace(HANJA_NOTE, '');
}

// 문장이 끝나는 자리 — 마침표 · 물음표 · 느낌표 · 말줄임표와 그 뒤에 붙은 닫는 따옴표 · 괄호까지.
const SENTENCE = /[^.!?。…]+[.!?。…]+["'”’」』)）]*|[^.!?。…]+$/g;
const CLAUSE = /[^,，、;:]+[,，、;:]*/g;

function pack(pieces: string[], max: number, glue: string): string[] {
    const out: string[] = [];
    let now = '';
    for (const piece of pieces) {
        if (now !== '' && (now + glue + piece).length > max) {
            out.push(now);
            now = piece;
        } else {
            now = now === '' ? piece : now + glue + piece;
        }
    }
    if (now !== '') out.push(now);
    return out;
}

function tidy(pieces: RegExpMatchArray | string[] | null): string[] {
    return (pieces ?? []).map((piece) => piece.trim()).filter((piece) => piece !== '');
}

// 긴 문장 하나를 max 안쪽 토막들로 — 쉼표, 빈칸, 그래도 안 되면 글자 수로.
function cut(sentence: string, max: number): string[] {
    if (sentence.length <= max) return [sentence];

    return pack(tidy(sentence.match(CLAUSE)), max, ' ').flatMap((clause) => {
        if (clause.length <= max) return [clause];

        return pack(clause.split(/\s+/), max, ' ').flatMap((words) => {
            if (words.length <= max) return [words];
            const hard: string[] = [];
            for (let at = 0; at < words.length; at += max) hard.push(words.slice(at, at + max));
            return hard;
        });
    });
}

// 한 줄(문단 안에서 줄바꿈으로 갈린 한 도막)을 읽힐 토막들로 만든다.
export function chunksOf(line: string, max: number = CHUNK_MAX): string[] {
    const text = dropHanja(line).replace(/\s+/g, ' ').trim();
    if (text === '') return [];

    return (
        tidy(text.match(SENTENCE))
            .flatMap((sentence) => cut(sentence, max))
            // 글자가 하나도 없는 토막(따옴표 · 줄표만 남은 것)은 읽힐 것이 없다
            .filter((chunk) => /[\p{L}\p{N}]/u.test(chunk))
    );
}
